export default function About() {
  return (
    <section id="about" className="bg-gray-50 py-32">
      <div className="max-w-7xl mx-auto px-12">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-widest text-gray-500 mb-4">About Us</p>
          <h2 className="text-5xl font-bold text-gray-900">Protecting Privacy Since Day One</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <p className="text-lg leading-relaxed text-gray-700 mb-6">
              At CONSTRUTORA MANUELLA LTDA, we believe that online privacy is a fundamental right. Our mission is to provide individuals and businesses with the tools they need to protect their digital identity and maintain complete anonymity online.
            </p>
            <p className="text-lg leading-relaxed text-gray-700">
              Founded with a commitment to transparency and security, we've built a VPN service that combines cutting-edge encryption technology with user-friendly design. We never log your activity, never compromise on security, and always put your privacy first.
            </p>
          </div>

          <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/2c45a648011d1ae899147d977690d4da.jpg"
              alt="Our Technology"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center">
            <div className="text-6xl font-bold text-cyan-500 mb-3">256-bit</div>
            <p className="text-gray-600 font-medium">Encryption Standard</p>
          </div>
          <div className="text-center">
            <div className="text-6xl font-bold text-cyan-500 mb-3">Zero-Log</div>
            <p className="text-gray-600 font-medium">Privacy Policy</p>
          </div>
          <div className="text-center">
            <div className="text-6xl font-bold text-cyan-500 mb-3">24/7</div>
            <p className="text-gray-600 font-medium">Customer Support</p>
          </div>
        </div>
      </div>
    </section>
  );
}
